const SET_SLOTS = "SET_SLOTS";

export {
    SET_SLOTS,
};
